import { jsx as _jsx } from "react/jsx-runtime";
import { FileQuestion, FileImage } from 'mdi-material-ui';
import PropTypes from "prop-types";
import * as SvgIcons from '../SvgIcons';
const FileIcon = ({ fontSize = 'medium', filename = '', }) => {
    const fileExtension = filename.split('.').pop();
    let FileIconComponent;
    switch (fileExtension) {
        case 'xlsx':
        case 'xls':
        case 'csv':
            FileIconComponent = SvgIcons.ExcelIcon;
            break;
        case 'pdf':
            FileIconComponent = SvgIcons.PdfIcon;
            break;
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
            FileIconComponent = FileImage;
            break;
        default:
            FileIconComponent = FileQuestion;
    }
    return _jsx(FileIconComponent, { fontSize: fontSize });
};
FileIcon.propTypes = {
    filename: PropTypes.string,
    fontSize: PropTypes.oneOf(['inherit', 'large', 'medium', 'small'])
};
export default FileIcon;
